import { z } from "zod";

import {
  Button,
  ColorIconSchema,
} from "@shared/content-types/schemas/common.schema";
import { RichTextContentSchema } from "@shared/content-types/schemas/richText.schema";

export const RuleSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  title: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  description: RichTextContentSchema,
  icon: ColorIconSchema,
});

export const RulesObjectSchema = z.object({
  id: z.number().int().positive(),
  title: z.string().min(1),
  rules: z.array(RuleSchema).min(0),
  button: Button.base.optional().nullable(),
});
